// extracted by mini-css-extract-plugin
export default {"Slider":"Slider_Slider__H8VM6","mark":"Slider_mark__4D1UO","thumb":"Slider_thumb__SJmS2","track":"Slider_track__R5nY9"};